// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderlessTableOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderlessTableOutlined";
import AntdIcon from '../components/AntdIcon';

var BorderlessTableOutlined = function BorderlessTableOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderlessTableOutlinedSvg
  }));
};

BorderlessTableOutlined.displayName = 'BorderlessTableOutlined';
export default React.forwardRef(BorderlessTableOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BorderlessTableOutlined.js
// module id = 673
// module chunks = 0